import { t, useLang, type Lang } from "../i18n";
import { Link } from "react-router-dom";
import type { ReactNode } from "react";
import { WallGlyph } from "./Wordmark";

/** Misafir sayfalarının ortak kabuğu (/giris ve ana sayfa; design_handoff_giris_sayfasi): 56 px başlık çubuğu + yasal footer. Ölçüler px (html 12 px tabanı). */
export const LANDING_WRAP = "w-full max-w-[1200px] mx-auto px-[clamp(20px,4vw,40px)]";

export function LandingShell({ children, actions }: { children: ReactNode; /** başlık çubuğunda dil seçicinin solu (ör. Giriş yap / Hesap oluştur) */ actions?: ReactNode }): JSX.Element {
  return (
    <div className="lp min-h-screen flex flex-col bg-page text-[#16233B]">
      <header className="bg-sheet border-b border-rule">
        <div className={`${LANDING_WRAP} h-[56px] flex items-center justify-between gap-[16px]`}>
          <Link to="/" className="inline-flex items-center gap-[8px] text-[17px] font-semibold tracking-[-0.02em]" aria-label={t("TaşDuvar ana sayfa")}><WallGlyph size={20} /><span>{t("TaşDuvar")}</span></Link>
          <nav className="flex items-center gap-[22px] text-[14px] text-[#3A3F45]" aria-label={t("Hesap")}>
            <Link to="/planlar" className="hover:text-[#16233B] max-sm:hidden">{t("Fiyatlar")}</Link>
            <Link to="/kilavuz" className="hover:text-[#16233B] max-sm:hidden">{t("Yardım")}</Link>
            {actions}
            <LandingLang />
          </nav>
        </div>
      </header>
      {children}
      <footer className="bg-sheet border-t border-rule">
        <div className={`${LANDING_WRAP} py-[14px] flex flex-wrap gap-x-[22px] gap-y-[8px] text-[12.5px] text-[#5A6068]`}>
          <span>© 2026 {t("TaşDuvar")}</span>
          <Link to="/kullanim-sartlari" className="hover:text-[#16233B]">{t("Kullanım şartları")}</Link>
          <Link to="/gizlilik" className="hover:text-[#16233B]">{t("Gizlilik bildirimi")}</Link>
          <Link to="/gizlilik" className="hover:text-[#16233B]">{t("KVKK aydınlatma metni")}</Link>
          <Link to="/on-bilgilendirme" className="hover:text-[#16233B]">{t("Ön bilgilendirme")}</Link>
          <Link to="/mesafeli-satis" className="hover:text-[#16233B]">{t("Mesafeli satış")}</Link>
        </div>
      </footer>
    </div>
  );
}

/** Numaralı kanıt listesi: satırlar arası 1 px çizgi, beyaz satırlar, mono numara. */
export function ProofList({ items, className = "" }: { items: [string, string, string][]; className?: string }): JSX.Element {
  return (
    <ol className={`grid gap-px bg-rule border border-rule rounded overflow-hidden ${className}`}>
      {items.map(([n, title, text]) => (
        <li key={n} className="bg-sheet px-[18px] py-[14px] grid grid-cols-[28px_1fr] gap-[12px] items-baseline">
          <span className="font-mono text-[12px] font-medium text-[#5A6068]" aria-hidden>{n}</span>
          <div><strong className="block text-[14.5px] font-semibold">{t(title)}</strong><span className="block mt-[2px] text-[13.5px] leading-[1.5] text-[#5A6068]">{t(text)}</span></div>
        </li>
      ))}
    </ol>
  );
}

/** Başlık çubuğu dil seçici (TR/EN, aria-pressed); seçim kalıcı, sayfa yenilenir. */
function LandingLang(): JSX.Element {
  const { lang, setLang } = useLang();
  const change = (l: Lang): void => {
    if (l === lang) return;
    setLang(l);
    if (import.meta.env.MODE !== "test") window.location.reload();
  };
  return (
    <span role="group" aria-label={t("Dil")} className="inline-flex gap-[2px]">
      {(["tr", "en"] as Lang[]).map((l) => (
        <button key={l} type="button" aria-pressed={lang === l} onClick={() => change(l)}
          className="px-[8px] py-[3px] rounded-[3px] text-[12.5px] border border-transparent text-[#5A6068] hover:text-[#16233B] aria-pressed:bg-[#F0EFEA] aria-pressed:border-rule aria-pressed:font-semibold aria-pressed:text-[#16233B]">{l.toUpperCase()}</button>
      ))}
    </span>
  );
}
